import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { btnStyle, mtsLoginLogo } from '../config/app.config';
import { routes } from '../config/routes.config';
import { HttpService } from '../main/http-service';

@Component({
   selector: 'app-forgotten-password',
   templateUrl: './forgotten-password.component.html',
   styleUrls: ['./forgotten-password.component.css'],
})
export class ForgottenPasswordComponent {
   btn = btnStyle;

   service: HttpService;

   showEmailSent= false;

   mtsLogo = mtsLoginLogo;

   forgottenPasswordForm = new FormGroup({
      username: new FormControl('', Validators.required),
      email: new FormControl('', [Validators.required, Validators.email]),
   });

   get username(): AbstractControl {
      return this.forgottenPasswordForm.get('username');
   }

   get email(): AbstractControl {
      return this.forgottenPasswordForm.get('email');
   }

   constructor(private route: ActivatedRoute, http: HttpClient, private router: Router) {
      this.service = new HttpService(
         http,
         routes.resetPassword,
         this.router,
         this.route,
      );
   }

   initValue(): void {
      this.username.reset();
      this.email.reset();
   }

   async submitForm(): Promise<void> {
      this.service.put(this.forgottenPasswordForm.value, (res) => { 
         this.showEmailSent = true;
      });
   }
}
